import http from './_http'

const Contact = {
  contactForm: data => http.post('/msvc/v1/contactform', data),
  contactFormArtwork: data => http.post('/msvc/v1/contactform/artwork', data),
  subscribeGalleryList: data => http.post('/msvc/v1/contactform/subscription', data),
  contactFormGallery: data => http.post('/msvc/v1/contactform/account', data)
}
export default Contact
